<div *ngIf="dataLoaded | async" class="phone-compatability-page flow pl-0" [ngClass]="{'container': windowWidth < 768}">
    <div *ngIf="windowWidth <= 768" [ngStyle]="{'margin': windowWidth>= 768 ? 'auto' : '0 auto'}" class="row col-10 question-text-cts mt-3 mb-40">{{ "Label.compatability_description" | translate}} {{storageService.getPhoneModel()['phoneModelName']}} and {{storageService.getBtVehicleYear().name ? storageService.getBtVehicleYear().name : storageService.getVehicleYear().name}}
        {{storageService.getBtVehicleModelName() ? storageService.getBtVehicleModelName() : storageService.getBtVehicleModel().name ? storageService.getBtVehicleModel().name : storageService.getVehicleModel().name}}
    </div>
    <div class="row" *ngIf="windowWidth > 768">
        <div class="col-12 p-0 mt-4 mb-4 navigation-arrow-text back-phone-link bt-back-page" (click)="backToManufacturerPage()">
            <span class="material-icons color-app bt-back-link" style="vertical-align: middle;">
                <mat-icon class="material-icons">chevron_left</mat-icon>
            </span>
            <span class="back-phone-text">Back To Phone Selection</span>
        </div>
        <div class="phone-compatability-block mt-3 col-10 pl-0">
            <div [ngStyle]="{'margin': windowWidth>= 768 ? 'auto' : '0 auto'}" class="row col question-text-cts mt-3 mb-40 justify-content-center">
                {{ "Label.compatability_description" | translate}} {{storageService.getPhoneModel()['phoneModelName']}} and {{storageService.getBtVehicleYear().name ? storageService.getBtVehicleYear().name : storageService.getVehicleYear().name}}
                {{storageService.getBtVehicleModelName() ? storageService.getBtVehicleModelName() : storageService.getBtVehicleModel().name ? storageService.getBtVehicleModel().name : storageService.getVehicleModel().name }}
                <div class="disclaimer" *ngIf="storageService.getShowDisclaimer()">
                    {{ "Label.disclaimer_compatability" | translate}}
                </div>
            </div>

            <div class="col-12 p-0 mb-4">
                <div class="col-12 d-flex header-compatability-table legend-table">

                    <span class="col" *ngFor="let legend of compatibleLegend">
                        <span class="d-flex">
                            <span class="mr-3">
                                <span class="material-icons" [ngClass]="legend.value" style="font-size: 30px;"></span>
                            </span>
                            <span class="legend-text">{{legend.name}}</span>
                        </span>
                    </span>
                </div>
            </div>
            <div class=" col-12 p-0 ">
                <div class="header-compatability-table col-12 ">
                    <div class="col-12 ">
                        <div class="col-12 d-flex ">
                            <div class="col header-feature-description ">{{ "Label.features" | translate}}</div>
                            <div class="col " *ngFor="let huInfo of this.phoneHUConfigInfoList[ 'headUnits'] ">
                                <div class="col feature-title-column ">
                                    <div class="title-span ">{{huInfo.huDescription}}</div>
                                    <div class="sub-title-span " #actionInfoTooltip="matTooltip" [matTooltip]="huInfo.softwareVersionText"
                                    matTooltipPosition="above" matTooltipShowDelay="100"
                                    matTooltipHideDelay="1500"
                                    [matTooltipClass]="{ 'tooltip-class-toyota' : isToyota , 'tooltip-class-lexus' : !isToyota }"
                                    (mouseenter)="hideTooltipIn(actionInfoTooltip, 2000, true,  0)"
                                    (mouseleave)="hideTooltipIn(actionInfoTooltip, 2000, false,  0)">Tested with {{huInfo.phoneOsVersion}} {{huInfo.phoneOsType}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <mat-accordion *ngIf="phoneFeatureList " class="mt-2 feature-accordion " style="margin:auto ">
                <mat-expansion-panel class=" " *ngFor="let phoneCompatability of phoneFeatureList.data.featureGroups;let fIndex=index; ">
                    <mat-expansion-panel-header>

                        <div class="col-12 compatability-table " [ngStyle]="{ 'margin-left': windowWidth>= 768 ? '30px' : '0px'}">
                            <div class="col-12 d-flex">
                                <div class="feature-description col">
                                    {{phoneCompatability.groupName}}
                                </div>
                                <div class="col" *ngFor="let huInfo of phoneHUConfigInfoList['headUnits'];">
                                    <app-compatible-icons [compatibleId]="huInfo.featureInfo.data.featureGroups[fIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['groupPhoneCompId']"></app-compatible-icons>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel-header>

                     <ng-template matExpansionPanelContent *ngIf="phoneCompatability && phoneCompatability['features']"> 
                        <div class="col-12 compatability-table feature-table">
                            <div *ngFor="let feats of phoneCompatability['features'];let featureIndex=index" class="col-12 feature-row d-flex">
                                <div class="feature-description col">
                                    <span>
                                        {{feats.featureName}}
                                    </span>
                                </div>
                                <div class="col icon-col" *ngFor="let huInfo of phoneHUConfigInfoList['headUnits'];let a=index;">
                                    <div *ngIf="huInfo.featureInfo.data.featureGroups[fIndex] && huInfo.featureInfo.data.featureGroups[fIndex].features && huInfo.featureInfo.data.featureGroups[fIndex].features[featureIndex]
                                        && huInfo.featureInfo.data.featureGroups[fIndex].features[featureIndex]['featureId'] && feats.featureId === huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]['featureId']">
                                    
                                        <app-compatible-icons [compatibleId]="huInfo.featureInfo.data.featureGroups[fIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]['featurePhoneCompId']"></app-compatible-icons>
                                        
                                    </div>
                                    <div *ngIf="huInfo.featureInfo.data.featureGroups[fIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]
                                        && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]['featureId'] && feats.featureId !== huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]['featureId'] ? setFeatureInfo(a,fIndex,featureIndex): false;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </div>
    <!-- HTML code IPad & Mobile devices -->


    <div class="row col-12 accordion-block" *ngIf="windowWidth <= 768">
        <div class="col-12 p-0 mt-4 mb-4 navigation-arrow-text back-phone-link" (click)="backToManufacturerPage()">
            <span class="material-icons color-app" style="vertical-align: middle;">chevron_left</span>
            <span class="back-phone-text">Back To Phone Selection</span>
        </div>
        <div class="col-11 m-auto p-0 mt-3 legend-block">
            <div class="row col-12 m-0 egend-block">
                <div class="col-6 p-0 legend-inner-block" style="text-align: left;" *ngFor="let legend of compatibleLegend;let i=index;">
                    <span class="mr-3">
                        <span [ngClass]="legend.value" style="font-size: 20px;"></span>
                    </span>
                    <span style="margin-top: 5px;color:black">{{legend.name}}</span>
                </div>
            </div>
        </div>
        <div class="col-12">
            <mat-accordion *ngIf="phoneFeatureList" class="col-12 mt-2 feature-accordion" style="margin:auto">
                <mat-expansion-panel class="responsive-mat-panel" *ngFor="let phoneCompatability of phoneFeatureList.data.featureGroups;let fIndex=index;">
                    <mat-expansion-panel-header>
                        <table aria-labelledby="Compatability" aria-describedby="Compatability" class="compatability-table" [ngStyle]="{'margin-left': windowWidth>= 768 ? '30px' : '0px'}"
                            [ngClass]="{'col-12' : windowWidth >= 768}">
                            <th id="compatability" style="display: none;">Compatability</th>
                            <tr class="col-12">
                                <td class="responsive-accordion-feature-description">
                                    {{phoneCompatability.groupName}} </td>
                            </tr>
                        </table>

                    </mat-expansion-panel-header>

                    <ng-template matExpansionPanelContent *ngIf="phoneCompatability && phoneCompatability['features']">

                        <!-- Implementation with HU accordion starts here -->

                        <mat-accordion *ngIf="phoneHUConfigInfoList['headUnits']">

                            <mat-expansion-panel *ngFor="let huInfo of phoneHUConfigInfoList['headUnits'];let hIndex=index;">
                                <mat-expansion-panel-header>
                                    <table aria-labelledby="Compatability" aria-describedby="Compatability" class="compatability-table" [ngStyle]="{'margin-left': windowWidth>= 768 ? '30px' : '0px'}"
                                        [ngClass]="{'col-12' : windowWidth >= 768}">
                                        <th id="compatability" style="display: none;">Compatability</th>
                                        <tr>
                                            <td class="responsive-accordion-feature-description">
                                                <div class="feature-title-column">
                                                    <div class="responsive-title-span">{{huInfo.huDescription}}</div>
                                                    <div class="responsive-sub-title-span">Tested with {{huInfo.phoneOsVersion}} {{huInfo.phoneOsType}}</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </mat-expansion-panel-header>

                                <table aria-labelledby="Compatability" aria-describedby="Compatability" class="col-12 compatability-table">
                                    <th id="compatability" style="display: none;">Compatability</th>
                                    <tr [ngClass]="{'col-2' : windowWidth >= 768}" *ngFor="let feats of phoneCompatability['features'];let featureIndex=index">
                                        <td>
                                            <div class="responsive-feature-description col-12" style="display:flex;padding-right: 0;">
                                                <div class="col-9 p-0">
                                                    <div class="col responsive-feature-title-column">
                                                        <div class="responsive-title-span">{{feats.featureName}}</div>
                                                    </div>
                                                </div>
                                                <div class="col-3 responsive-icon-block">
                                                    <app-compatible-icons [compatibleId]="huInfo.featureInfo.data.featureGroups[fIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex] && huInfo.featureInfo.data.featureGroups[fIndex]['features'][featureIndex]['featurePhoneCompId']"></app-compatible-icons>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </mat-expansion-panel>
                        </mat-accordion>

                    </ng-template>

                </mat-expansion-panel>

            </mat-accordion>
        </div>
    </div>
</div>